import { useCallback, useState } from "react";
//import LogoMini from "../../../components/icons/LogoMini";
//import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
//import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import IGPanOptic from "../../../assets/img/SolutionsIcons/AgilysysIGPanOpticKiosk.svg";
import { Header } from "../../../components/Header";
import { useLocation } from "react-router-dom";

const IGPanOpticKioskFPage = () => {
    //const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const { pathname } = useLocation();
    const altText = () => {
      if (pathname.split("/")[1] === "communities")
        return "resident"
      else
        return "guest"
    }
    const altText2 = () => {
        if (pathname.split("/")[1] === "communities")
          return "residents'"
        else
          return "guest's"
      }
    return(
        <div className="page splash IGPanOpticKioskFPage">
            <div className="page-title"><img src={IGPanOptic} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                IG PanOptic Kiosk is an AI-powered self-checkout kiosk 
                that allows customers to simply place multiple food items 
                on the kiosk tray all at one time.{'\n\n'} 
                </div>
                <div className="std-text">
                As soon as the guest places items on the tray, the PanOptic 
                AI service uses computer vision and AI to scan the items, 
                recognize them, initiate a new shopping cart and 
                automatically add items.
                </div>
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGPanOpticKiosk1.png"} alt="" />
        </div>
    )
}

export default IGPanOpticKioskFPage;